import { render, staticRenderFns } from "./ConfigOption.vue?vue&type=template&id=2c199a69&"
import script from "./ConfigOption.vue?vue&type=script&lang=js&"
export * from "./ConfigOption.vue?vue&type=script&lang=js&"
import style0 from "./ConfigOption.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports